const PASSWORD_VALIDATION =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+~`{}.,<>?;:'"|/[\]\\])(?=.{6,})/

export default PASSWORD_VALIDATION
